import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FiSun, FiMoon } from 'react-icons/fi';
import { useTheme } from '../services/contexts/theme-context';

const ThemeToggle = styled.button`
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: none;
  border: none;
  color: var(--text-main);
  font-size: 1rem;
  font-weight: 700;
  cursor: pointer;
  transition: color 0.3s ease, transform 0.2s ease;
  padding: 0.5rem;
  border-radius: 8px;
  width: 100%;
  justify-content: ${props => props.isOpen ? 'flex-start' : 'center'};

  &:hover {
    background: var(--border-color);
    transform: scale(1.02);
  }

  svg {
    stroke-width: 2;
    flex-shrink: 0;
  }

  span {
    margin-left: 0.5rem;
    white-space: nowrap;
  }
`;

export default function ThemeToggler({ isOpen = true }) {
  const { theme: primeTheme, setTheme: setPrimeTheme, isThemeLoading } = useTheme();
  const [isLight, setIsLight] = useState(() => primeTheme.includes('light'));

  useEffect(() => {
    // Update local state when theme changes
    const isLightTheme = primeTheme.includes('light');
    setIsLight(isLightTheme);
  }, [primeTheme]);

  const toggleTheme = () => {
    if (isThemeLoading) return; // Prevent multiple clicks during loading
    const newPrimeTheme = isLight ? 'lara-dark-blue' : 'lara-light-blue';
    setPrimeTheme(newPrimeTheme);
  };

  return (
    <ThemeToggle 
      onClick={toggleTheme} 
      aria-label="Toggle theme" 
      isOpen={isOpen}
      disabled={isThemeLoading}
      style={{ 
        opacity: isThemeLoading ? 0.6 : 1,
        cursor: isThemeLoading ? 'not-allowed' : 'pointer'
      }}
    >
      {isThemeLoading ? (
        <div style={{ 
          width: '20px', 
          height: '20px', 
          border: '2px solid var(--text-main)', 
          borderTop: '2px solid transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite'
        }} />
      ) : isLight ? (
        <FiSun size={20}/> // sun icon golden
      ) : (
        <FiMoon size={20} /> // moon icon default theme color
      )}
      {isOpen && <span>{isThemeLoading ? 'Switching...' : (isLight ? 'Light Mode' : 'Dark Mode')}</span>}
    </ThemeToggle>
  );
}
